/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactMaterialFromJSON, ContactMaterialToJSON } from './ContactMaterial';
export function GetContactMaterialsExpiredListResponseDataFromJSON(json) {
    return GetContactMaterialsExpiredListResponseDataFromJSONTyped(json, false);
}
export function GetContactMaterialsExpiredListResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contactMaterials: !exists(json, 'contact_materials')
            ? undefined
            : json['contact_materials'].map(ContactMaterialFromJSON)
    };
}
export function GetContactMaterialsExpiredListResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact_materials: value.contactMaterials === undefined
            ? undefined
            : value.contactMaterials.map(ContactMaterialToJSON)
    };
}
